<template>
	<div class="grid pb-0">
		<div class="border-top-unset">
			<v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
			<div class="d-content-mobile" v-if="!isLoading">
				<label class="s-label">{{ $t("SALE_CHANNEL") }}</label>
				<v-select item-text="text" item-value="value" :items="listOTA" v-model="selectedOTA" outlined dense
					@change="getRelation(true)">
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-select>
				<label class="s-label mt-2">{{ $t("ROOM_CLASS") }}</label>
				<v-select item-text="text" item-value="value" :items="listRoom" v-model="selectedRoom" outlined dense>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-select>
				<label class="s-label mt-2">{{ $t("ROOMPLAN") }}</label>
				<v-select item-text="text" item-value="value" :items="listRoomPlan" v-model="selectedRoomPlan" outlined
					dense>
					<template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-select>
				<p class="mt-2 mb-0 text-right fs-10">{{ $t('UNIT') }}: {{ currency }}</p>
				<div v-if="listRoomPlan.length > 0">
					<FunctionalCalendar v-model="calendarData" :disabled-dates="calendarConfigs.disabledDates"
						:is-multiple="true" :is-date-range="false" :date-format="'yyyy/mm/dd'" :calendars-count="1"
						@choseDay="chooseDate($event)" @changedMonth="changedMonth($event)"
						@changedYear="changedMonth($event)" :dayNames="calendarConfigs.dayNames"
						:monthNames="calendarConfigs.monthNames" :shortMonthNames="calendarConfigs.shortMonthNames"
						:change-month-function='true' :change-year-function='true'>
						<template v-slot:default="props">
							<span class="fs-16 d-date-day font-weight-bold" :class="checkWeekend(props.day.date)">{{
								props.day.day < 10 ? '0' + props.day.day : props.day.day }}</span>
									<div class="text-center" @click="chooseDate(props.day)"
										:class="checkStopSell(props.day.date) ? 'date-stopSell' : 'price-mobile-calendar'"
										v-if="rateSpecial(props.day.date) === -1 && checkDayOfMonth(props.day.date)">
										<span class="fs-10"
											:class="relationData.find(e => e.id === selectedRoom).ratePlans.find(pl => pl.id === selectedRoomPlan).roomRates[0].linkedRoomRateId ? 'text-master-rate' : ''">{{
												priceFormat(
													relationData.find(e => e.id === selectedRoom).ratePlans.find(pl => pl.id ===
														selectedRoomPlan).roomRates[0][
													formatDateOfWeekInPrice(new Date(props.day.date))
													]
												)
											}}</span>
									</div>
									<div class="text-center"
										:class="checkStopSell(props.day.date) ? 'date-stopSell' : 'price-mobile-calendar-special'"
										v-if="rateSpecial(props.day.date) !== -1 && checkDayOfMonth(props.day.date)"
										@click="chooseDate(props.day)">
										<span class="fs-10 font-weight-bold"
											:class="parseRoomRateSpecial(rateSpecial(props.day.date))">{{
												priceFormat(
													relationData.find(e => e.id === selectedRoom).ratePlans.find(pl => pl.id ===
														selectedRoomPlan)
														.roomRates[0].roomRateSpecials.find(date => date.appliedDate === _moment(new
															Date(props.day.date)).format("YYYY-MM-DD")).pricePax
												)
											}}</span>
									</div>
						</template>
					</FunctionalCalendar>

				</div>
				<div class="d-note-action">
					<ul class="pl-0 d-flex justify-content-between flex-wrap">
						<li class="mr-5">
							<span class="font-weight-bold">000</span>
							{{ $t("DAILY_PRICE") }}
						</li>
						<li class="mr-5">
							<span class="text-smart font-weight-bold">000</span>
							{{ $t("DYNAMIC_PRICING") }}
						</li>
						<li>
							<span class="text-master-rate">000</span>
							{{ $t("MASTER_RATE") }}
						</li>
						<li>
							<span class="text-master-rate font-weight-bold">000</span>
							{{ $t("DAILY_MASTER_RATE") }}
						</li>
						<li>
							<span class="i-square bg-stopSell"></span>
							{{ $t("closed") }}
						</li>
					</ul>
					<div v-if="checkRoleFunc('RATE')">
						<v-btn depressed color="primary" class="fs-10 w-100" @click="openUpdateRange">
							{{ $t('UPDATE_RATE_BY_RANGE') }} </v-btn>
					</div>
				</div>
			</div>
		</div>
		<div id="overlay" @click="closeNav()"></div>
		<div id="my-update" class="sidenav-search" v-if="!isLoading">
			<v-toolbar class="toolbar-update" dense>
				<v-toolbar-title class="text-primary fs-15">
					<strong>{{ $t('UPDATE_FOR', { date: _moment(new Date(dateUpdate)).format("DD/MM/YYYY") }) }}</strong>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon light @click="closeNav()">
					<v-icon color="primary">
						close
					</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="content-update">
				<p class="mb-0" v-if="listOTA.length > 0"><label class="s-label"><span class="font-weight-bold">{{
					$t("BOOKING_CHANNEL") }}:</span> {{ listOTA.find(e => e.value === selectedOTA) ? listOTA.find(e => e.value === selectedOTA).text : ''}}</label>
				</p>
				<p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
					$t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span> {{ listRoom.find(e => e.value ===
		selectedRoom) ? listRoom.find(e => e.value ===
		selectedRoom).text : '' }}</label></p>
				<p class="mb-0" v-if="listRoomPlan.length > 0"><label class="s-label"><span class="font-weight-bold">{{
					$t("_SALE_PACKAGE.SALE_PACKAGE") }}:</span> {{ listRoomPlan.find(e => e.value ===
		selectedRoomPlan) ? listRoomPlan.find(e => e.value ===
		selectedRoomPlan).text : '' }}</label></p>
				<label class="s-label"><span class="font-weight-bold">{{ $t("SERVICE.PRICE") }}</span></label>
				<vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
					v-model="priceUpdate" />

				<v-row>
					<v-col v-if="rateSpecial(dateUpdate) !== -1">
						<v-btn color="error" class="w-100" @click="removeSpecialPrice">
							{{ $t("REMOVE_SPECIAL_PRICE") }}
						</v-btn>
					</v-col>
					<v-col>
						<v-btn color="primary" @click="confirmUpdateSpecialPrice()" class="w-100">
							{{ $t("UPDATE") }}
						</v-btn>
					</v-col>
				</v-row>
			</div>
		</div>
		<div id="my-batch-update" class="sidenav-search">
			<v-toolbar dense class="toolbar-update-range">
				<v-btn icon light @click="closeUpdateRange()">
					<v-icon color="grey darken-2">
						arrow_back_ios
					</v-icon>
				</v-btn>

				<v-toolbar-title class="grey--text text--darken-4 fs-15">
					<strong>{{ $t('UPDATE_SELLING_PRICES_IN_STAGES') }}</strong>
				</v-toolbar-title>
			</v-toolbar>
			<div class="h-100 content-update-range overflow-auto">
				<label class="pr-0 fs-10"> {{ $t("ROOM_CLASS") }} </label>
				<v-chip-group v-model="selectedRoomTypeUpdate" :column="true" multiple pill active-class="primary--text">
					<v-chip filter v-for="(i, index) in listRoomUpdate" :value="i.value" class="w-100 mb-1 mr-0">
						{{ i.text }}
					</v-chip>
				</v-chip-group>
				<!-- <v-autocomplete item-text="text" item-value="value" :items="listRoomUpdate" v-model="selectedRoomTypeUpdate" outlined chips dense multiple deletable-chips> -->
				<!-- <template v-slot:selection="data">
						<v-chip
							v-bind="data.attrs"
							:input-value="data.selected"
							close
							@click="data.select"
							@click:close="remove(data.item, selectedRoomTypeUpdate)"
							>
							{{ data.item.text }}
						</v-chip>
					</template> -->
				<!-- <template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete> -->
				<label class="pr-0 fs-10 mt-3"> {{ $t("ROOMPLAN") }} </label>
				<v-chip-group v-model="selectedRatePlanUpdate" :column="true" multiple pill active-class="primary--text">
					<v-chip filter v-for="(i, index) in listRatePlan" :value="i.value" class="w-100 mb-1 mr-0">
						{{ i.text }}
					</v-chip>
				</v-chip-group>
				<!-- <v-autocomplete item-text="text" item-value="value" :items="listRatePlan" v-model="selectedRatePlanUpdate" outlined chips dense multiple deletable-chips> -->
				<!-- <template v-slot:selection="data">
						<v-chip
							v-bind="data.attrs"
							:input-value="data.selected"
							close
							@click="data.select"
							@click:close="remove(data.item, selectedRatePlanUpdate)"
							>
							{{ data.item.text }}
						</v-chip>
					</template> -->
				<!-- <template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete> -->
				<label class="pr-0 fs-10 mt-3"> {{ $t("SALE_CHANNEL") }} </label>
				<v-chip-group v-model="selectedOtaUpdate" :column="true" multiple pill active-class="primary--text">
					<v-chip filter v-for="(i, index) in listOtaUpdate" :value="i.value" class="w-100 mb-1 mr-0">
						{{ i.text }}
					</v-chip>
				</v-chip-group>
				<!-- <v-autocomplete item-text="text" item-value="value" :items="listOtaUpdate" v-model="selectedOtaUpdate" outlined chips dense multiple deletable-chips> -->
				<!-- <template v-slot:selection="data">
						<v-chip
							v-bind="data.attrs"
							:input-value="data.selected"
							close
							@click="data.select"
							@click:close="remove(data.item, selectedOtaUpdate)"
							>
							{{ data.item.text }}
						</v-chip>
					</template> -->
				<!-- <template slot="no-data">
						<div class="no-data">{{ $t("NO_DATA") }}</div>
					</template>
				</v-autocomplete> -->
				<label class="pr-0 fs-10 mt-3"> {{ $t("TIME_APPLICATION") }} </label>
				<date-picker :disabled-date="notBeforeToday" :confirm="true" :confirm-text="$t('CONFIRM')"
					:clearable="false" :editable="false" :popup-class="'popup-calendar-mobile'" v-model="dateSelect"
					:lang="languageDate" :format="'DD/MM/YYYY'" :shortcuts=[] range placeholder="Select date range">
				</date-picker>

				<label class="fs-10 mt-3">{{ $t("PRICE") }} <span class="fs-8">({{ $t('DATA_INPUT_MUST_BE_GREATER_THAN_0')
				}})</span></label>
				<vuetify-number :options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" dense outlined
					v-model="priceUpdate" />

				<v-btn class="btn-update" color="primary" @click="confirmUpdateRangePrice()"
					:disabled="selectedRoomTypeUpdate.length === 0 || selectedRatePlanUpdate.length === 0 || selectedOtaUpdate.length === 0">
					{{ $t("UPDATE") }}
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar';
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
	components: {
		FunctionalCalendar,
		"date-picker": DatePicker,
	},
	data() {
		return {
			isLoading: true,
			selectedRoom: -1,
			listRoom: [],
			calendarConfigs: {
				dayNames: [
					`${this.$t('T2')}`,
					`${this.$t('T3')}`,
					`${this.$t('T4')}`,
					`${this.$t('T5')}`,
					`${this.$t('T6')}`,
					`${this.$t('T7')}`,
					`${this.$t('T8')}`,
				],
				monthNames: [
					`${this.$t('TH1')}`,
					`${this.$t('TH2')}`,
					`${this.$t('TH3')}`,
					`${this.$t('TH4')}`,
					`${this.$t('TH5')}`,
					`${this.$t('TH6')}`,
					`${this.$t('TH7')}`,
					`${this.$t('TH8')}`,
					`${this.$t('TH9')}`,
					`${this.$t('TH10')}`,
					`${this.$t('TH11')}`,
					`${this.$t('TH12')}`,
				],
				shortMonthNames: [
					`${this.$t('TH1')}`,
					`${this.$t('TH2')}`,
					`${this.$t('TH3')}`,
					`${this.$t('TH4')}`,
					`${this.$t('TH5')}`,
					`${this.$t('TH6')}`,
					`${this.$t('TH7')}`,
					`${this.$t('TH8')}`,
					`${this.$t('TH9')}`,
					`${this.$t('TH10')}`,
					`${this.$t('TH11')}`,
					`${this.$t('TH12')}`,
				],
				calendarsCount: 2,
				isMultiple: true,
				isDateRange: true,
				hiddenElements: ['leftAndRightDays'],
				disabledDates: ['beforeToday'],
				dateFormat: 'yyyy/mm/dd',
			},
			relationData: [], // Thông tin gói bán và giá của tất cả phòng do API trả về
			selectedDatePicker: moment()
				.startOf("day")
				.format("YYYY-MM-DD"),
			systemLang: this.$i18n.locale,
			listRoomPlan: [],
			listOTA: [],
			selectedRoomPlan: [],
			obDateData: null,
			dateUpdate: null,
			currency: JSON.parse(localStorage.getItem("currency")),
			priceUpdate: 0,
			listRoomUpdate: [],
			selectedRoomTypeUpdate: [],
			hasRoomRate: [],
			listRatePlan: [],
			selectedOtaUpdate: [],
			listOtaUpdate: [],
			selectedRatePlanUpdate: [],
			dateSelect: [],
			defaultWeekend: [],
			listRatePlanByRateCategory: [],
			otaCodeEdit: null,
		};
	},
	watch: {
		selectedRoom(val) {
			if (val) {
				this.listRoomPlan = [];
				this.relationData.find(e => e.id === val).ratePlans.forEach(element => {
					this.listRoomPlan.push({
						value: element.id,
						text: element.i18ns.find((y) => y.lang == this.defaultI18n).name,
					})
				});
				this.selectedRoomPlan = this.listRoomPlan[0].value;
			}
		},
		selectedRoomPlan() {
			setTimeout(() => {
				// var nodeItems = document.getElementsByClassName('price-mobile-calendar');
				// for (let item of nodeItems) {
				// 	item.parentElement.style.background = '#4ECB39';
				// 	item.parentElement.style.setProperty('color', '#fff');
				// }
				// var nodeItemsSpecial = document.getElementsByClassName('price-mobile-calendar-special');
				// for (let item of nodeItemsSpecial) {
				// 	item.parentElement.style.background = '#FF4D4F';
				// 	item.parentElement.style.setProperty('color', '#fff');
				// }
				var nodeItemsWeekend = document.getElementsByClassName('d-weekend-mobile');
				for (let item of nodeItemsWeekend) {
					item.parentElement.style.background = '#FFF5F5';
				}
				var nodeItemsStop = document.getElementsByClassName('date-stopSell');
				for (let item of nodeItemsStop) {
					item.parentElement.style.background = '#FFD17B';
					// item.parentElement.style.setProperty('color', '#fff');
				}
			}, 200);
		},
		selectedRoomTypeUpdate(val) {
			let listRatePlans = [];
			this.hasRoomRate.forEach(r => {
				if (val.includes(r.id)) {
					r.ratePlans.forEach(p => {
						listRatePlans.push({
							value: p.id,
							text: p.i18ns.find((y) => y.lang == this.defaultI18n).name,
						})
					})
				}
			})
			this.listRatePlan = Array.from(new Set(listRatePlans.map(JSON.stringify))).map(JSON.parse);
		},
		selectedRatePlanUpdate(val) {
			const listOtas = [];
			this.hasRoomRate.forEach(r => {
				if (this.selectedRoomTypeUpdate.includes(r.id)) {
					r.ratePlans.forEach(p => {
						if (this.selectedRatePlanUpdate.includes(p.id)) {
							p.roomRates.forEach(o => {
								if (o.ota.otaCode !== 'EZ_PMS') {
									listOtas.push({
										value: o.ota.id,
										text: o.ota.otaI18n.find((y) => y.lang == this.defaultI18n).name,
									});
								}

							});
						}
					});
				}
			});
			this.listOtaUpdate = Array.from(new Set(listOtas.map(JSON.stringify))).map(JSON.parse);
		},
	},
	mounted() {
		this.initialize();
	},
	methods: {
		initialize() {
			this.currency = this.priceOptionsVi.suffix;
			const fromDateListOfPeriod = moment(new Date()).format("YYYY-MM-DD");
			const toDateListOfPeriod = moment(new Date())
				.add(1, "day")
				.format("YYYY-MM-DD");

			this.dateSelect = [new Date(fromDateListOfPeriod), new Date(toDateListOfPeriod)];
			let hotelWeekend = JSON.parse(localStorage.getItem("hotelWeekend"));
			// Chuyển từ binary sang select
			var tmp = this.convertFromBinaryToListSelection(hotelWeekend);
			const el = this;
			this.defaultWeekend = [];
			tmp.forEach(function (element, index) {
				if (element == 1) {
					if (index == 0) {
						el.defaultWeekend.push("MON");
					}
					if (index == 1) {
						el.defaultWeekend.push("TUE");
					}
					if (index == 2) {
						el.defaultWeekend.push("WED");
					}
					if (index == 3) {
						el.defaultWeekend.push("THU");
					}
					if (index == 4) {
						el.defaultWeekend.push("FRI");
					}
					if (index == 5) {
						el.defaultWeekend.push("SAT");
					}
					if (index == 6) {
						el.defaultWeekend.push("SUN");
					}
				}
			});
			this.getAllRoomDefault();


		},
		convertFromBinaryToListSelection(number) {
			let output = parseInt(number, 10).toString(2);
			while (output.length < 7) {
				output = "0" + output;
			}
			return output.split("");
		},
		checkWeekend(date) {
			const weekday = ["SUN", "MON", "TUE", "WED", "THU", "FRIFRI", "SAT"];
			let day = weekday[new Date(date).getDay()];
			return this.defaultWeekend.includes(day) ? 'd-weekend-mobile' : ''
		},
		async getAllRoomDefault() {
			await restriction.getAllRoomTyeHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					this.hasRoomRate = res.data;
					this.listRoomUpdate = [];
					this.listRoomUpdate = this.listRoomUpdate.concat(
						res.data.map((room) => {
							return {
								value: room.id,
								text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
							};
						})
					);
					this.getOTA();
				}
			});
		},
		checkDayOfMonth(date) {
			const dayOfMonth = new Date(date).getMonth();
			const m = new Date(this.selectedDatePicker).getMonth();
			return dayOfMonth === m
		},
		async getOTA() {
			await syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
				if (res.responseCode === 0) {
					this.listOTA = res.data.map((x) => {
						return {
							value: x.id,
							text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
							code: x.otaCode
						};
					});
					this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
					this.selectedOTA = this.listOTA[0].value;
					this.getAllPlanByRateCategory();

				} else {
					_alert(res, this.$t(res.data), false);
				}
			});
		},
		changedMonth(val) {
			this.selectedDatePicker = moment(new Date(val).setDate(1)).format("YYYY-MM-DD");
			this.getRelation();
		},
		async getAllPlanByRateCategory() {
			await sale_room
				.getAllRatePlanByCategory()
				.then((res) => {
					var data = [];
					res.data.forEach(e => {
						if (e.ratePlans.length > 0) {
							data = data.concat([...e.ratePlans.map(pl => pl.id)])
						}
					})
					this.listRatePlanByRateCategory = [...data];
					this.getRelation(true);
				})
		},
		getRelation(val) {
			this.otaCodeEdit = this.listOTA.find(x => this.selectedOTA === x.value).code
			var fromDate = this.selectedDatePicker;
			var toDate = moment(this.selectedDatePicker)
				.add(30, "day")
				.format("YYYY-MM-DD");

			let body = {
				from: fromDate,
				to: toDate,
				roomTypeIds: [...this.listRoomUpdate.map(e => e.value)],
				otaId: this.selectedOTA,
				ratePlanIds: [...this.listRatePlanByRateCategory],
				rateCategoryIds: []
			};
			sale_room
				.getAllRelation(body)
				.then(res => {
					if (res.responseCode === 0) {
						// Lấy data hiển thị cho table
						this.relationData = res.data;
						if (val) {
							this.loadListRoom(this.relationData);
						}
						setTimeout(() => {
							var nodeItems = document.getElementsByClassName('price-mobile-calendar');
							// for (let item of nodeItems) {
							// 	item.parentElement.style.background = '#4ECB39';
							// 	item.parentElement.style.setProperty('color', '#fff');
							// }
							// var nodeItemsSpecial = document.getElementsByClassName('price-mobile-calendar-special');
							// for (let item of nodeItemsSpecial) {
							// 	item.parentElement.style.background = '#FF4D4F';
							// 	item.parentElement.style.setProperty('color', '#fff');
							// }
							var nodeItemsWeekend = document.getElementsByClassName('d-weekend-mobile');
							for (let item of nodeItemsWeekend) {
								item.parentElement.style.background = '#FFF5F5';
							}
							var nodeItemsStop = document.getElementsByClassName('date-stopSell');
							for (let item of nodeItemsStop) {
								item.parentElement.style.background = '#FFD17B';
								// item.parentElement.style.setProperty('color', '#fff');
							}
						}, 200);
					} else {
						_alert(res, this.$t(res.data), false);
					}
				})
				.finally(() => (this.isLoading = false));
		},
		loadListRoom(data) {
			this.listRoom = [];
			this.selectedRoom = null;
			this.selectedRoomPlan = null;
			this.listRoomPlan = [];
			let rooms = data.filter(e => e.ratePlans.length > 0);
			this.listRoom = this.listRoom.concat(
				rooms.map(room => {
					return {
						value: room.id,
						text: room.roomTypeI18n.find(x => x.lang === this.defaultI18n).name
					};
				})
			);
			this.selectedRoom = this.listRoom.length > 0 ? this.listRoom[0].value : null;
			if (this.selectedRoom) {
				this.relationData.find(e => e.id === this.selectedRoom).ratePlans.forEach(element => {
					this.listRoomPlan.push({
						value: element.id,
						text: element.i18ns.find((y) => y.lang == this.defaultI18n).name,
					})
				});
				this.selectedRoomPlan = this.listRoomPlan.length > 0 ? this.listRoomPlan[0].value : null;
			}

		},
		formatDateOfWeekInPrice(date) {
			let dayOfWeek;
			switch (moment(date).day()) {
				case 0: {
					dayOfWeek = "paxSunday";
					break;
				}
				case 1: {
					dayOfWeek = "paxMonday";
					break;
				}
				case 2: {
					dayOfWeek = "paxTuesday";
					break;
				}
				case 3: {
					dayOfWeek = "paxWednesday";
					break;
				}
				case 4: {
					dayOfWeek = "paxThursday";
					break;
				}
				case 5: {
					dayOfWeek = "paxFriday";
					break;
				}
				case 6: {
					dayOfWeek = "paxSaturday";
					break;
				}
			}
			return dayOfWeek;
		},
		priceFormat(val) {
			const value =
				Math.abs(val) >= 999999 && Math.abs(val) < 1000000000
					? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(2)}M`
					: Math.abs(val) >= 1000000000
						? `${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(2)}B`
						: Math.abs(val) === 0
							? `0`
							: Math.abs(val) < 1000 ? Math.abs(val) : `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(2)}K`;
			return value;
		},
		checkStopSell(date) {
			if (this.selectedRoomPlan && this.relationData.find(e => e.id === this.selectedRoom)
				&& this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan)
				&& this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).restrictions.find(d => d.appliedDate === moment(new Date(date)).format('YYYY-MM-DD'))
				&& this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).restrictions.find(d => d.appliedDate === moment(new Date(date)).format('YYYY-MM-DD')).closed
			) {
				return true
			} else return false
		},
		rateSpecial(date) {
			if (this.selectedRoomPlan &&
				this.relationData.find(e => e.id === this.selectedRoom)
				&& this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).roomRates[0].roomRateSpecials.length > 0
				&& this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).roomRates[0].roomRateSpecials.find(d => d.appliedDate === moment(new Date(date)).format('YYYY-MM-DD'))
				&& this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).roomRates[0].roomRateSpecials.find(d => d.appliedDate === moment(new Date(date)).format('YYYY-MM-DD')).pricePax > -1
			) {
				return this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).roomRates[0].roomRateSpecials.find(d => d.appliedDate === moment(new Date(date)).format('YYYY-MM-DD')).priceBy
			} else return -1
		},
		parseRoomRateSpecial(value) {
			switch (value) {
				case 0:
					return 'font-weight-bold'
				case 1:
					return 'font-weight-bold text-smart'
				case 2:
					return 'font-weight-bold text-master-rate'
				default:
					return '';
			}
		},
		chooseDate(val) {
			if (this.checkRoleFunc('RATE') == false) return
			this.dateUpdate = val.date;
			if (this.otaCodeEdit === 'EZ_PMS') return
			if (this.rateSpecial(val.date) !== -1) {
				this.priceUpdate = this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan)
					.roomRates[0].roomRateSpecials.find(date => date.appliedDate === moment(new Date(val.date)).format("YYYY-MM-DD")).pricePax
			} else {
				this.priceUpdate = this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).roomRates[0][this.formatDateOfWeekInPrice(new Date(val.date))]
			}
			if (new Date(moment(new Date(val.date)).format("YYYY-MM-DD")).getTime() >= new Date(moment(new Date()).format("YYYY-MM-DD")).getTime()) {
				this.openUpdate();
			}

		},
		openUpdate() {
			document.getElementById('overlay').style.display = 'block';
			document.getElementById('overlay').style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
			document.getElementById('my-update').style.top = 0;
		},
		closeNav() {
			if (document.getElementById('my-update').offsetTop === 0) {
				document.getElementById('overlay').style.display = 'none';
				document.getElementById('my-update').style.top = '-100vh';
			}
		},
		confirmUpdateSpecialPrice() {
			var body = [];
			const dateValue = [];
			dateValue.push({
				apply: moment(new Date(this.dateUpdate)).format("YYYY-MM-DD"),
				value: this.priceUpdate
			});
			if (this.priceUpdate > 0) {
				body.push({
					id: this.relationData.find(e => e.id === this.selectedRoom).ratePlans.find(pl => pl.id === this.selectedRoomPlan).roomRates[0].id,
					dates: dateValue
				});
			} else {
				_alert(null, this.$t("DATA_INPUT_INVALID"));
			}
			sale_room
				.updateSpecialPrice(body)
				.then(res => {
					_alert(res, this.$t(res.data), false);
				})
				.finally(() => {
					this.closeNav();
					this.getRelation();
				});
		},
		removeSpecialPrice() {
			let id = this.relationData.find(e => e.id === this.selectedRoom)
				.ratePlans.find(pl => pl.id === this.selectedRoomPlan)
				.roomRates[0].roomRateSpecials.find(z => z.appliedDate == moment(new Date(this.dateUpdate)).format("YYYY-MM-DD")).id;
			let body = [id];

			sale_room
				.removeSpecialPrice(body)
				.then(res => {
					_alert(res, this.$t(res.data), true);
				})
				.finally(() => {
					this.closeNav();
					this.getRelation();
				});
		},
		openUpdateRange() {
			this.priceUpdate = 0;
			document.getElementById('my-batch-update').style.top = 0;
			// document.getElementById('my-batch-update').style.bottom = 0;
			document.getElementById('overlay').style.display = 'block';
			document.getElementById('overlay').style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
		},
		closeUpdateRange() {
			// document.getElementById('my-batch-update').style.bottom = '-100vh';
			document.getElementById('my-batch-update').style.top = '-100vh';
			document.getElementById('overlay').style.display = 'none';
		},
		confirmUpdateRangePrice() {
			if (this.get_day_of_time(new Date(this.dateSelect[0]), new Date(this.dateSelect[1])) > 365) {
				_alert(null, this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR"));
				return true
			}
			const roomRateIds = [];
			const body = [];
			this.hasRoomRate.forEach(r => {
				if (this.selectedRoomTypeUpdate.includes(r.id)) {
					r.ratePlans.forEach(p => {
						if (this.selectedRatePlanUpdate.includes(p.id)) {
							p.roomRates.forEach(o => {
								if (this.selectedOtaUpdate.includes(o.ota.id)) {
									roomRateIds.push(o.id);
								}
							});
						}
					});
				}
			});
			var dateValue = [];
			let fromDate = moment(this.dateSelect[0], "YYYY/MM/DD");
			let toDate = moment(this.dateSelect[1], "YYYY/MM/DD");
			while (fromDate <= toDate) {
				dateValue.push({
					apply: fromDate.format("YYYY-MM-DD"),
					value: this.priceUpdate,
				});
				fromDate = moment(fromDate).add(1, "day");
			}
			roomRateIds.forEach(roomRate => {
				body.push({
					id: roomRate,
					dates: dateValue
				});
			});
			if (this.priceUpdate > 0 && this.selectedRoomTypeUpdate.length > 0 && this.selectedRatePlanUpdate.length > 0 && this.selectedOtaUpdate.length > 0) {
				sale_room
					.updateSpecialPrice(body)
					.then(res => {
						_alert(res, this.$t(res.data), false);
					})
					.finally(() => {
						this.closeUpdateRange();
						this.getRelation();
					});
			} else {
				_alert(null, this.$t("DATA_INPUT_INVALID"));
			}
		},
		remove(item, arr) {
			const index = arr.indexOf(item.value)
			if (index >= 0) arr.splice(index, 1)
		},
		_moment: moment
	}
};
</script>
